export type SortOrder = 'asc' | 'desc';

type SortOrderWithNone = SortOrder | undefined; // undefined is used to reset the sort order

/**
 * @deprecated always option is deprecated
 */
export type SortModeDeprecated = 'always';

export type SortMode = SortModeDeprecated | SortOrderWithNone[];
